// Layout & spacing tokens for shared use by page-level primitives
// (PageContainer / PageHeader / Section / FormGrid / DataGridFrame ...).
//
// Values follow MUI's spacing scale: 1 unit = 8px. Use directly in
// `sx={{ p: SECTION_INNER }}` etc.

export const PAGE_PADDING_X = 3;   // 24px - page left/right
export const PAGE_PADDING_Y = 3;   // 24px - page top/bottom
export const PAGE_MAX_WIDTH = 1400; // px - max content width on wide screens

export const SECTION_GAP = 3;   // 24px between sibling sections
export const SECTION_INNER = 2; // 16px padding inside a section

export const FORM_GAP = 2;          // 16px between form rows
export const FORM_LABEL_COL = 200;  // px, fixed left label column for 2-col forms

export const DATAGRID_ROW_HEIGHT = 56;

// Semantic spacing scale (used by primitives, NOT directly in pages)
export const SPACE = {
  xs: 0.5, // 4px  - icon gaps, chip gaps
  sm: 1,   // 8px  - field-internal elements
  md: 2,   // 16px - form rows, table row groups
  lg: 3,   // 24px - section padding, page padding
  xl: 4,   // 32px - between major content blocks
};
